// Generated TypeScript interfaces for interval_kind

export enum IntervalEntryKind {
  NORMAL = "normal",
  ON_CALL_ON_SITE = "on_call_on_site",
  ON_CALL_OFF_SITE = "on_call_off_site",
  DISTURBANCE = "disturbance"
}

